import { useQuery } from "@tanstack/react-query"
import { loopReturnsIntegrationQuery } from "../../lib/loopReturns/loopReturnsIntegrationQuery"

export function useLoopReturnsIntegrationQuery(
  ...args: Parameters<typeof loopReturnsIntegrationQuery>
) {
  return useQuery(loopReturnsIntegrationQuery(...args))
}
